import { useState } from "react";
import ChangePasswordModal from "./change-password-modal";
import { useSelector } from "react-redux";
import { getUserData } from "../../../AsianExchangeSrc/utils/helper/commonSelectors";

const MyProfile = () => {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const UserData = useSelector(getUserData())

  const handleEditPassword = () => {
    setIsPasswordModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsPasswordModalOpen(false);
  };

  return (
    <>
      <div className=" bg-light-bg dark:bg-dark-bg p-1 rounded-md ">
        <div className="shadow-lg">
          <div className="bg-[linear-gradient(-180deg,_#2E4B5E_0%,_#243A48_82%)] px-2 py-1">
            <h1 className="text-white text-sm font-semibold">
              Account Details
            </h1>
          </div>

          <div className="bg-light-bg dark:bg-dark-bg p-1 space-y-3">
            <div className="">
              <label className="block text-black dark:text-white text-sm mb-2 border-b border-gray-300 px-3 p-1 font-semibold">
                Name
              </label>
              <div className="text-black dark:text-white text-sm border-b border-gray-300 px-3 p-1">
                {UserData?.userName || "N/A"}
              </div>
            </div>

            <div>
              <label className="block text-black dark:text-white text-sm mb-2 border-b border-gray-300 px-3 p-1 font-semibold">
                Commission
              </label>
              <div className="text-black dark:text-white text-sm border-b border-gray-300 px-3 p-1">
                {UserData?.commission || "N/A"}
              </div>
            </div>

            <div>
              <label className="block text-black dark:text-white text-sm mb-2 border-b border-gray-300 px-3 p-1 font-semibold">
                Exposure Limit
              </label>
              <div className="text-black dark:text-white text-sm border-b border-gray-300 px-3 p-1">
                {UserData?.exposureLimit || "N/A"}
              </div>
            </div>

            <div className=" pb-5">
              <label className="block text-black dark:text-white text-sm mb-2 border-b border-gray-300 px-3 p-1 font-semibold">
                Password
              </label>
              <div className="flex items-center space-x-3 border-b border-gray-300 px-3 p-1">
                <span className="text-black dark:text-white text-sm">••••••••••</span>
                <button
                  onClick={handleEditPassword}
                  className="text-blue-500 text-sm hover:text-blue-600 transition-colors flex items-center space-x-1"
                >
                  <span>Edit</span>
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ChangePasswordModal
        isOpen={isPasswordModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default MyProfile;
